// src/helpers/rutaAdelantoChofer.js
import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

function authHeaders() {
  const token = localStorage.getItem("token") || "";
  return { headers: { token } };
}

export const getAdelantoChoferes = async (params = {}) => {
  try {
    const resp = await axios.get(`${BASE_URL}/adelantochofer`, {
      ...authHeaders(),
      params,
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener adelantos",
    };
  }
};

export const postAdelantoChofer = async (payload) => {
  try {
    const resp = await axios.post(`${BASE_URL}/adelantochofer`, payload, {
      ...authHeaders(),
      headers: {
        ...authHeaders().headers,
        "Content-Type": "application/json",
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al guardar adelanto",
    };
  }
};

export const deleteAdelantoChofer = async (id) => {
  try {
    const resp = await axios.delete(`${BASE_URL}/adelantochofer/${id}`, authHeaders());
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al anular adelanto",
    };
  }
};

export const getAdelantoChoferById = async (id) => {
  try {
    const resp = await axios.get(`${BASE_URL}/adelantochofer/${id}`, authHeaders());
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener adelanto",
    };
  }
};

export const putAdelantoChofer = async (id, payload) => {
  try {
    const resp = await axios.put(`${BASE_URL}/adelantochofer/${id}`, payload, {
      ...authHeaders(),
      headers: {
        ...authHeaders().headers,
        "Content-Type": "application/json",
      },
    });

    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar adelanto",
    };
  }
};